import Link from "next/link";
import Layout from "../../components/shared/layout/layout";
import CollapsibleEvent from "../../components/collapsibleEvent/collapsibleEvent";
import Form from "../../components/form/form";
import {useState} from "react";
import styles from "../../styles/pages/weinkauf/shop/kassa.module.css";
import Seo from "../../components/shared/seo/seo";


export default function News() {
    return (
        <Layout>
            <Seo
                title="Kontakt"
                description="Kontakt zum Weingut Gisperg: Anschrift, Besuch am Weingut, Anfrage-Formular, Newsletter und Jobs."
                path="/kontakt"
            />
            <div id="loading" className="loading">
                <div className="ldsHeart">
                    <div></div>
                </div>
                <p className="annotation white">Anfrage wird gesendet...</p>
            </div>
            <section className="background_light no_fill">
                <div className="col-12">
                    <h1 style={{marginBottom:"30px"}}>Kontakt</h1>
                    <div className="horizontal">
                        <div className="col-3">
                            <Link href="#anschrift"><p className="annotation marker brown link">Anschrift</p></Link>
                        </div>
                        <div className="col-3">
                            <Link href="#besuchamweingut"><p className="annotation marker brown link">Besuch am Weingut</p>
                            </Link>
                        </div>
                        <div className="col-3">
                            <Link href="#formular"><p className="annotation marker brown link">Formular</p></Link>
                        </div>
                    </div>
                    <div className="horizontal">
                        <div className="col-3">
                            <Link href="#newsletter"><p className="annotation marker brown link">Newsletter</p></Link>
                        </div>
                        <div className="col-3">
                            <Link href="#jobs"><p className="annotation marker brown link">Jobs</p></Link>
                        </div>
                    </div>
                </div>
                <div className="horizontal" style={{marginTop:"100px"}}>
                    <div className="col-4 left">
                        <span  className="anchor" id="anschrift" ></span>
                        <h2>Anschrift</h2>
                        <p>Burgundermacher<br/>Weingut Johann Gisperg</p>
                        <p>Hauptstraße 14<br/>2524 Teesdorf<br/>Thermenregion NÖ</p>
                    </div>
                    <div className="col-4">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2672.2181343055777!2d16.27608961628136!3d47.95150577920915!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476db6a9281a34eb%3A0x35a183de80c59665!2sBurgundermacher%20Weingut%20Johann%20Gisperg!5e0!3m2!1sen!2sat!4v1665236808792!5m2!1sen!2sat"
                            width="100%" height="100%" style={{border:0}} loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"/>
                    </div>
                    <div className="col-4">
                       <p>So erreichen Sie uns am schnellsten:<br/><br/>
                           Von Wien kommend: 	Abfahrt Traiskirchen<br/>
                           Von Süden kommend: 	Abfahrt Leobersdorf
                           B17 bis ÖAMTC-Fahrtechnikzentrum
                           Richtung Teesdorf abbiegen
                           <br/><br/>
                           In Teesdorf nach der Unterführung beim alten Feuerwehrhaus noch vor der Brücke rechts in die Hauptstraße abbiegen
                       </p>
                    </div>
                </div>
            </section>
            <section className="background_light_texture">
                <div className="horizontal">
                    <div className="col-6 left vertical-center">
                        <img alt=""  src="/images/besuchamweingut.webp" width="642" height="433"/>
                    </div>
                    <div className="col-6 right">
                        <span  className="anchor" id="besuchamweingut" ></span>
                        <h2 className="white">Besuch am Weingut</h2>
                        <p>Die Tore unseres Weinguts stehen für Sie weit offen. Sie wollen Ihren Besuch mit einer oder mehreren Nächten in der Thermenregion verbinden?<br/>
                            Unsere Weinbauregion lädt zu langen Radtouren oder Spaziergängen durch die Weingärten, Thermenbesuchen und vielem mehr ein. Von Übernachtungsmöglichkeiten nur wenige Schritte vom Weingut  entfernt, bis hin zum Sterne- Hotel in einer unserer Kulturstädte, ist alles dabei.
                            <br/><br/>
                            Während unseren Öffnungszeiten stehen wir Ihnen gerne für  Weineinkäufe und Verkostungen zu Verfügung. Kontaktieren Sie uns und wir freuen uns, Sie bald auf unserem Weingut willkommen zu heißen.  </p>
                    </div>
                </div>
            </section>
            <section className="background_light">
                <span  className="anchor" id="formular" ></span>
                <div className="col-12" style={{maxWidth:"1200px"}}>
                    <span  className="anchor" id="anschrift" ></span>
                    <h2>Formular</h2>
                    <Form/>
                </div>
            </section>
            <section className="background_lighter">
                <span  className="anchor" id="jobs"></span>
                <h2>Jobs</h2>
                <div className="col-3">
                    <p className="brown information start uppercase">Wir suchen...</p>
                    <hr size="1" width="100%"/>
                    <div className="horizontal" style={{justifyContent:"space-between"}}>
                        <p>Praktikant*in</p>
                        <p className="underline"><a  href ="/documents/Stellenauschreibung_Praktikum.pdf" target="_blank">PDF downloaden</a></p>
                    </div>
                    <hr size="1" width="100%"/>
                </div>
            </section>
        </Layout>
    );
}